<template>
  <div class="settings-table">
    <label v-if="label" class="settings-table-label">{{ label }}<vue-feather v-if="tooltip" type="info" size="14" class="label-tooltip-icon" v-tooltip="tooltip" /></label>
    <div v-for="(item, index) in items" :key="index" class="settings-table-row">
      <div class="settings-table-fields">
        <slot name="row" :item="item" :index="index" />
      </div>
      <div v-if="editing || $slots.actions" class="settings-table-actions">
        <slot name="actions" :item="item" :index="index" />
        <BaseButton v-if="removable(item, index)" icon="trash-2" variant="danger-outline" @click="$emit('remove', index)" />
      </div>
    </div>
    <BaseButton v-if="editing && canAdd" icon="plus" @click="$emit('add')" />
    <p v-if="!editing && items.length === 0" class="settings-table-empty">{{ emptyMessage }}</p>
  </div>
</template>

<script>
import BaseButton from '../buttons/BaseButton.vue'
import VueFeather from 'vue-feather'

export default {
  name: 'SettingsTable',
  components: { BaseButton, 'vue-feather': VueFeather },
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: true
    },
    removable: {
      type: Function,
      default: () => true
    },
    emptyMessage: {
      type: String,
      default: 'None configured'
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  emits: ['add', 'remove']
}
</script>

<style>
.settings-table-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.settings-table-label .label-tooltip-icon {
  color: #9ca3af;
  cursor: help;
  flex-shrink: 0;
}

.settings-table-row {
  display: flex;
  gap: 12px;
  align-items: end;
  margin-bottom: 12px;
}

.settings-table-fields {
  display: flex;
  flex: 1;
  gap: 12px;
  min-width: 0;
}

.settings-table-fields > * {
  flex: 1;
  min-width: 0;
}

.settings-table-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.settings-table-empty {
  font-size: 0.875rem;
  color: #9ca3af;
  margin: 0;
  padding: 0;
}
</style>
